import React from "react";

import { Delete } from "icons";
import Pluralize from "pluralize";
import { isEmpty } from "ramda";

import { Button, Typography, SearchBar } from "clearsense-ui/components";
import AnimatedAction from "components/Common/AnimatedAction";

const ActionHeader = ({
  search,
  setSearch,
  totalCount,
  setIsDeleteAlertOpen,
  checkedRows,
}) => (
  <div className="flex justify-between my-4">
    <div className="flex items-center w-2/6 space-x-4">
      <Typography style="large" type="bold">
        {Pluralize("Files", totalCount ?? 0, true)}
      </Typography>
      <AnimatedAction>
        {!isEmpty(checkedRows) && (
          <Button
            label="Delete"
            icon={Delete}
            className="text-red-700 hover:bg-gray-300"
            style="secondary"
            onClick={() => setIsDeleteAlertOpen(true)}
            data-cy="delete-domain-button"
          />
        )}
      </AnimatedAction>
    </div>
    <div
      className="flex items-center w-2/6 space-x-4"
      data-cy="files-subheader-right-action-block-div"
    >
      <SearchBar
        placeholder="Search Files"
        className="w-40"
        value={search}
        onChange={e => setSearch(e.target.value.trim())}
      />
    </div>
  </div>
);

export default ActionHeader;
